import React, { useCallback, useState } from 'react';

import Link from 'corp/components/UI/IsomorphicLink/IsomorphicLink';
import { Button } from 'design-system/Button';
import { makeStyles } from 'design-system/styles';
import { Owner } from '@scale/shared/types/corp/lookup';
import UpdateProjectOwnersModal from './UpdateProjectOwnersModal';

type Props = {
  corpPermissionRoleId: string;
  owners: Owner[];
};

const ProjectOwners = ({ owners, corpPermissionRoleId }: Props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setModalIsOpen(true);
  }, [setModalIsOpen]);

  const styles = useStyles();
  return (
    <>
      <Button className={styles['project-owners__edit-button']} onClick={openModal} type="tertiary">
        Edit
      </Button>
      {owners.map((owner, index) => (
        <>
          <Link key={owner._id} href={`/lookup/${owner._id}`}>
            {owner.email}
          </Link>
          {index !== owners.length - 1 ? <span>, </span> : null}
        </>
      ))}
      <UpdateProjectOwnersModal
        isOpen={modalIsOpen}
        corpPermissionRoleId={corpPermissionRoleId}
        setModalIsOpen={setModalIsOpen}
        owners={owners}
      />
    </>
  );
};

const useStyles = makeStyles({
  'project-owners__edit-button': {
    marginRight: 8,
  },
  ownersList: {
    marginTop: 12,
    marginBottom: 12,
    wordBreak: 'break-all',
  },
});

export default ProjectOwners;
